import classNames from 'classnames';
import { Flex, Heading } from 'yoso';
import { LanguageButton } from '~/components/I18n/LanguageButton';
import { Discord, Dosi, Twitter } from '~/components/Icon';
import { Medium } from '~/components/Icon/Medium';
import { InlineList } from '~/components/List/Inline/InlineList';
import { useMember } from '~/components/Member/Member.hooks';
import { TermLink } from '~/components/Term/Link/TermLink';
import { useGitbookUrl, useTwitterUrl } from '~/components/Url/Url.hooks';
import { T } from '../I18n';
import './Footer.scss';

export type FooterProps = {
  className?: string;
};

const DOSI_MEMBERS_URL = import.meta.env.VITE_DOSI_MEMBERS_URL;
const DOSI_URL = import.meta.env.VITE_DOSI_URL;
export const Footer = ({ className }: FooterProps) => {
  const { data } = useMember();
  const { region = 'GL' } = data || {};
  const gitbookUrl = useGitbookUrl();
  const twitterUrl = useTwitterUrl();

  return (
    <div className={classNames('footer', className)}>
      <div className="footer-body">
        <Heading level={2}>
          <a href={DOSI_URL} className="display-block">
            <Dosi display="block" />
          </a>
        </Heading>
        <InlineList className="footer-term-list" divided>
          <li>
            <TermLink href={`${DOSI_MEMBERS_URL}/terms/tos/member`}>
              <T name="citizen_tos_member" />
            </TermLink>
          </li>
          <li>
            <TermLink href={`${DOSI_MEMBERS_URL}/terms/tos/market`}>
              <T name="citizen_tos_market" />
            </TermLink>
          </li>
          <li>
            <TermLink href={`${DOSI_MEMBERS_URL}/terms/tos/citizen`}>
              <T name="citizen_tos_membership" />
            </TermLink>
          </li>
          <li>
            <TermLink href={`${DOSI_MEMBERS_URL}/terms/privacy_policy/pp`}>
              <T name="citizen_pp" />
            </TermLink>
          </li>
          {region !== 'KR' && (
            <li>
              <TermLink href={`${DOSI_MEMBERS_URL}/terms/marketing_policy/mp`}>
                <T name="citizen_mp" />
              </TermLink>
            </li>
          )}
          <li>
            <a target="_blank" href="/support/help">
              <T name="citizen_help" />
            </a>
          </li>
          <li>
            <a target="_blank" href={import.meta.env.VITE_INQUIRY_FORM_URL} rel="noreferrer">
              <T name="citizen_contact" />
            </a>
          </li>
          <li>
            <a target="_blank" href={gitbookUrl} rel="noreferrer">
              <T name="citizen_footer_about" />
            </a>
          </li>
          {region === 'JP' && (
            <>
              <li className="jp-term-list-item">
                <TermLink href={`${DOSI_MEMBERS_URL}/terms/tos_others_store/asct_seller_jp`}>
                  特定商取引法に基づく表示 (当社が販売事業者の場合)
                </TermLink>
              </li>
              <li className="jp-term-list-item">
                <TermLink href={`${DOSI_MEMBERS_URL}/terms/tos_others_store/asct_storeseller_jp`}>
                  特定商取引法に基づく表示 (当社以外が販売事業者の場合)
                </TermLink>
              </li>
              <li className="jp-term-list-item">
                <TermLink href={`${DOSI_MEMBERS_URL}/terms/tos_others_store/asct_provider_jp`}>
                  特定商取引法に基づく表示 (役務提供事業者)
                </TermLink>
              </li>
            </>
          )}
        </InlineList>
        <InlineList className="footer-copyright-list" divided>
          <li>Powered by DOSI</li>
          <li>© LINE NEXT Inc. All rights reserved</li>
        </InlineList>
      </div>
      <Flex container alignItems="center" className="footer-footer" justifyContent="space-between">
        <Flex>
          <InlineList className="external-service-list">
            <li>
              <a target="_blank" href="https://discord.gg/SCkEdqTJG7" rel="noreferrer">
                <Discord display="block" />
              </a>
            </li>
            <li>
              <a target="_blank" href={twitterUrl} rel="noreferrer">
                <Twitter display="block" />
              </a>
            </li>
            <li>
              <a target="_blank" href="https://medium.com/@DOSI_official" rel="noreferrer">
                <Medium display="block" />
              </a>
            </li>
          </InlineList>
        </Flex>
        <Flex>
          <LanguageButton />
        </Flex>
      </Flex>
    </div>
  );
};
